var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    directives: [{
      name: "intersect",
      rawName: "v-intersect",
      value: _vm.onIntersect,
      expression: "onIntersect"
    }],
    staticClass: "overflow-hidden",
    staticStyle: {
      "aspect-ratio": "5 / 7"
    }
  }, [_vm.show ? [!_vm.design.key ? [_vm.full ? _c('card-preview', {
    attrs: {
      "card": _vm.full,
      "is-card-owner": true
    },
    on: {
      "loaded": _vm.end
    }
  }) : _vm._e()] : _vm._e(), _vm.isVideo ? [_vm.IS_IOS_SAFARI ? _c('picture', [_c('source', {
    attrs: {
      "type": "video/mp4",
      "srcset": _vm.base + _vm.design.key + '_270x378.mp4'
    }
  }), _c('source', {
    attrs: {
      "type": "image/webp",
      "srcset": _vm.base + _vm.design.key + '_200x280.webp'
    }
  }), _c('img', {
    staticClass: "d-block loading-icon",
    class: {
      loaded: _vm.loadEnded
    },
    attrs: {
      "width": "100%",
      "type": "image/jpeg",
      "src": _vm.base + _vm.design.key + '_poster_270x378.jpg',
      "alt": _vm.alt
    },
    on: {
      "load": _vm.end,
      "error": _vm.end,
      "abort": _vm.end
    }
  })]) : _c('video', {
    staticClass: "d-block loading-icon",
    class: {
      loaded: _vm.loadEnded
    },
    attrs: {
      "width": "100%",
      "playsinline": "",
      "autoplay": "",
      "muted": "",
      "loop": "",
      "poster": _vm.base + _vm.design.key + '_poster_270x378.jpg',
      "src": _vm.base + _vm.design.key + '_270x378.mp4',
      "aria-label": _vm.alt
    },
    domProps: {
      "muted": true
    },
    on: {
      "loadeddata": _vm.end,
      "error": _vm.end,
      "abort": _vm.end
    }
  })] : _c('img', {
    staticClass: "d-block loading-icon",
    class: {
      loaded: _vm.loadEnded
    },
    attrs: {
      "width": "100%",
      "src": _vm.base + _vm.design.key + '_270x378.jpg',
      "alt": _vm.alt
    },
    on: {
      "load": _vm.end,
      "error": _vm.end,
      "abort": _vm.end
    }
  })] : _vm._e()], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }